import { IconButton, Stack, useTheme } from "@mui/material";
import { Pencil } from "lucide-react";
import type { FC } from "react";
import { GoalDetailMenu } from "web_myplann/Goals/Components/GoalDetailMenu";
import type { GoalDetail } from "web_myplann/Goals/Types/GoalDetail";

type Props = {
	goal: GoalDetail;
	goalId: number;
	onEdit: () => void;
	onBlocked: () => void;
};

export const GoalDetailHeaderActions: FC<Props> = ({
	goal,
	goalId,
	onEdit,
	onBlocked,
}) => {
	const theme = useTheme();

	return (
		<Stack direction="row" gap={1}>
			<GoalDetailMenu goal={goal} goalId={goalId} onBlocked={onBlocked} />
			<IconButton variant="soft" onClick={onEdit}>
				<Pencil size={theme.iconSize.sm} />
			</IconButton>
		</Stack>
	);
};
